<header></header>
<div id="wrapper">
  <plyca-ui-splitter [config]="layoutConfig()" class="layout" [class.not-gutter]="!isDesktop() || isGeneralRoute()" (startResizeChange)="startResize($event)" (endResizeChange)="endResize($event)">
    <ng-template let-element="layout" let-i="index">
      @if (i === 0) {
        <div id="panelSplitterMain">
          <ng-container *ngTemplateOutlet="panelTemplate; context: { $implicit: layout, index: i }" />
        </div>
      }
      @if (isDesktop() && i === 1) {
        <div class="layout__container-block">
          <div [class]="'ml-1 mr-1 ' + (hasSubheaderSig() ? 'layout__container' : ' mt-1')">
            <div class="mb-3 ml-3 mr-1 layout__container-banner" app-follow-top-help>
              <plyca-ui-banner-generic
                [config]="{
                  classButtonClose: '',
                  isButtonClose: true,
                  iconCloseClass: 'fa fa-close text-white',
                  background: 'bg-azul1',
                  iconMain: 'mt-2 ml-1 fa fa-question fa-3x'
                }"
                class="w-100"
                (clickEvent)="closeHelp()"
              >
                <div class="d-flex align-items-center mb-2">
                  <div class="d-flex mr-3">
                    <plyca-ui-button-history
                      [config]="{
                        buttonClass: 'layout__container-button-nav layout__container-button-nav-left mr-1',
                        type: 'button',
                        icon: 'fa fa-arrow-left',
                        disabled: !canGoBackSig(),
                        historyItems: historyItemsSig(),
                        panelStyleClass: 'layout-history-panel'
                      }"
                      (clickEvent)="backHelp()"
                      (historySelect)="onHistorySelect($event)"
                    >
                      <i class="fa fa-chevron-left text-white" [style.opacity]="canGoBackSig() ? '1' : '0.5'" aria-hidden="true"></i>
                    </plyca-ui-button-history>
                    <plyca-ui-button-generic
                      [config]="{ buttonClass: 'layout__container-button-nav layout__container-button-nav-right', type: 'button' }"
                      (clickEvent)="forwardHelp()"
                      [disabled]="!canGoForwardSig()"
                    >
                      <i class="fa fa-chevron-right text-white" [style.opacity]="canGoForwardSig() ? '1' : '0.5'" aria-hidden="true"></i>
                    </plyca-ui-button-generic>
                  </div>
                  <h2 class="font-bold flex-grow-1 layout__container-banner-title" [innerHTML]="'General.ayuda' | translate"></h2>
                </div>
                @if (currentTagSig() && isUserAdmin()) {
                  <p class="layout__container-context" [innerHTML]="currentTagSig()"></p>
                }
                <plyca-ui-button-generic [config]="{ buttonClass: 'layout__container-button-refresh', type: 'button' }" (clickEvent)="refreshHelp()">
                  <i [class]="'fa fa-refresh text-white ' + (searchingSig() ? 'fa-spin' : '')" aria-hidden="true"></i>
                </plyca-ui-button-generic>
              </plyca-ui-banner-generic>
            </div>
            <div class="ml-2 mr-1">
              @if (searchingSig() && isOpenHelp()) {
                <div class="layout__container-loading">
                  <span class="layout__container-loading--icon">
                    <i class="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i>
                  </span>
                </div>
              } @else if (!isGeneralHelp()) {
                @if (!isGeneralRoute()) {
                  <div class="col-12 p-0 text-right mb-3 mt-3">
                    <plyca-ui-button-generic [config]="{ buttonClass: 'btn btn-xs btn-secondary layout__container-button-full-version', type: 'button' }" (clickEvent)="onNavigateGeneralHelp()">
                      <span
                        ><p class="mr-1 layout__container-button-full-version-text" [innerHTML]="'GeneralHelp.fullVersion' | translate"></p>
                        <i class="fa fa-external-link" aria-hidden="true"></i>
                      </span>
                    </plyca-ui-button-generic>
                  </div>
                }
                <div
                  class="animated fadeIn animate__delay-2s layout__container-general-help"
                  [class.layout__container-general-help--not-route]="isGeneralRoute()"
                  [class.d-none]="!isHelpOpen()"
                  [id]="generalHelpConst.RefScroll"
                  [style.max-width]="sideSubPanelWidthSig()"
                >
                  <plyca-general-help [config]="{ mode: selectHelpMode.ACCORDION, isSidebar: true }" />
                </div>
              } @else {
                <div
                  class="animated fadeIn animate__delay-2s layout__container-help-result"
                  [id]="generalHelpConst.RefScroll"
                  [class.layout__container-help-result--not-help]="!groupedHelpSig()?.length"
                  [style.max-width]="sideSubPanelWidthSig()"
                >
                  <plyca-help-element-result [searchTags]="searchTagsSig()" [groupedHelp]="groupedHelpSig()" />
                </div>
              }
              <div class="position-fixed layout__container-button-up">
                <plyca-ui-button-generic [config]="{ buttonClass: 'btn btn-xs btn-secondary layout__container-button-up--rounded', type: 'button' }" (clickEvent)="onClickScrollToTop()">
                  <span> <i class="fa fa-angle-double-up" aria-hidden="true"></i> </span>
                </plyca-ui-button-generic>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-template>
  </plyca-ui-splitter>
</div>
